import { Injectable } from '@angular/core';
import {NetworkFilterService} from '../network/network-filter.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ConnectionFilterService {

  constructor() {}

  public static mapFilter(connections: any, searchObject: any): any {

    const searchableFields = ['nodes', 'pCons', 'connections', 'voipPeers', 'operative state', 'name'];

    let filteredConnections = _.cloneDeep(connections);

    const searchObjectCopy = NetworkFilterService.formatSearchObject(searchObject);

    const filterByName = (connectionList, nameObject) => {
      if (nameObject && nameObject.value) {
        connectionList = connectionList.filter((connection) => {
          return connection.name.toLowerCase().indexOf(nameObject.value.toLowerCase()) > -1;
        });
      }
      return connectionList;
    };

    const filterByOperState = (connectionList, operStateObject) => {
      if (operStateObject && operStateObject.value) {
        connectionList = connectionList.filter((connection) => {
          if (!_.isArray(operStateObject.value)) {
            return  operStateObject.value.toLowerCase() ===  getConnectionOperState(connection);
          }
          return operStateObject.value.find((state) => {
            return  state.toLowerCase() === getConnectionOperState(connection);
          });
        });
      }
      return connectionList;
    };

    const getConnectionOperState = (connectionList) => {
      if (connectionList.connections.length > 1) {
        if (connectionList.connections[0].operState.toLowerCase() === 'unavailable' ||
          connectionList.connections[1].operState.toLowerCase() === 'unavailable') {
          return 'unavailable';
        } else {
          return 'available';
        }
      } else {
        return connectionList.connections[0].operState.toLowerCase();
      }
    };

    const markfilteredConnections = (connectionList, filtered) => {
      connectionList = connectionList.map((connection) => {
        connection.filtered = isElementFiltered(filtered, connection);
        return connection;
      });
      return connectionList;
    };

    const isElementFiltered = (array, searchedObject) => {
      return !!array.find((arrayItem) => {
        return arrayItem.id === searchedObject.id;
      });
    };

    if (!searchObjectCopy) {
      return connections;
    }

    if (searchObjectCopy.freeText) {
      searchObjectCopy.name = {value: searchObjectCopy.freeText};
      filteredConnections = filterByName(filteredConnections, searchObjectCopy.name);
      return markfilteredConnections(connections, filteredConnections);
    }

    if (!searchObjectCopy.connections) {
      return markfilteredConnections(connections, []);
    }

    if (NetworkFilterService.haveNonSearchableFields(searchObjectCopy, searchableFields)) {
      return markfilteredConnections(connections, []);
    }

    if (!searchObjectCopy.connections.value || searchObjectCopy.connections.value === 'no') {
      return markfilteredConnections(connections, []);
    }

    filteredConnections = filterByName(filteredConnections, searchObjectCopy.name);
    filteredConnections = filterByOperState(filteredConnections, searchObjectCopy['operative state']);
    return markfilteredConnections(connections, filteredConnections);
  }

  public static testRouteFilter(connections: any, testRoutePath: any): any {
    const connectionsToFilter = [];

    if (testRoutePath.edges) {
      testRoutePath.edges.forEach((edge) => {
        if (connectionsToFilter.indexOf(edge.connectionId) === -1) {
          connectionsToFilter.push (edge.connectionId);
        }
      });
    }

    connections = connections.map((connection) => {
      if (connectionsToFilter.filter((connectionToFilter) => {
        return connectionToFilter === connection.id; }).length > 0) {
        connection.testRouteFilter = true;
      }
      return connection;
    });
    return connections;
  }
}
